import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export type UpdateAggregationTableDataType = {
  successCallback?: Function;
  errorCallback?: Function;
  resultKey: string;
  params: {
    from_date: string;
    to_date: string;
  };
};

export default ({
  successCallback,
  errorCallback,
  resultKey = 'aggregationTableData',
  params,
}: UpdateAggregationTableDataType) =>
  requestAsync({
    url: endpoints.updateAggregationTableUrl(params),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.updateAggregationTableUrl(params),
    options: {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
